import Bullet from 'components/prism/bullet';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const ToDo = ({ data, profileId, history }) => {
    return (
        <>
            <div className="flex flex-center mb10">
                <h2>
                    Your to-do list
                    <span className="ml10" style={{ fontWeight: 400 }}>
                        {data?.length}
                    </span>
                </h2>
            </div>
            {data.map(item => {
                let link = '';

                switch (item.type) {
                    case 'review':
                        link = `/develop/reviews/${profileId}`;
                        break;
                    default: // objective
                        link = `/objectives/${profileId}`; ///objective/${item.id}`;
                        break;
                }

                return (
                    <div key={`todo-${item.id}`} className="prism-content-box mt10">
                        <div className="prism-content">
                            <div className="flex flex-center">
                                <Bullet type={item.type} />
                                <h4 className="ml10">
                                    <Link to={link}>{item.name}</Link>
                                </h4>
                            </div>
                            {item.description && <p>{item.description}</p>}
                            <div>
                                <Bullet isDate value={item.due} />
                                {item.duration && (
                                    <span className="ml10">
                                        <Bullet isDuration value={item.duration} />
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default ToDo;
